import { Component, OnInit } from '@angular/core';
import { SelectOption } from '../../../../inputs/select/model/select-option';
import { AbstractCalculatorComponentEmitsValue } from '../abstract-calculator-component-emits-value.directive';
import { PriceCountry } from '../../../../models/price/price';

@Component({
  selector: 'psc-calculator-country-picker',
  templateUrl: './calculator-country-picker.component.html'
})
export class CalculatorCountryPickerComponent extends AbstractCalculatorComponentEmitsValue implements OnInit {

  name = 'country';

  countriesOptions: SelectOption[] = [
    { label: 'HR', value: PriceCountry.HR },
    { label: 'BIH - Federacija', value: PriceCountry.BA_FE },
    { label: 'BIH - Republika Srpska', value: PriceCountry.BA_RS },
  ];

  override get controlName(): string {
    return this.name;
  }

  override ngOnInit() {
    super.ngOnInit();
    if (!this.advanced) {
      this.control?.setValue(PriceCountry.HR);
      this.control?.updateValueAndValidity();
      this.changeDetector.detectChanges();
    }
  }

  protected readonly PriceCountry = PriceCountry;
}
